(() => {
  const BUTTON_SELECTOR = '.shopify-payment-button__button--unbranded';
  const TRANSLATED_LABEL = 'Купити';

  const translateButtons = () => {
    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      if (button.textContent.trim() !== TRANSLATED_LABEL) {
        button.textContent = TRANSLATED_LABEL;
      }

      if (button.hasAttribute('aria-label')) {
        button.setAttribute('aria-label', TRANSLATED_LABEL);
      }
    });
  };

  let updateQueued = false;

  const queueUpdate = () => {
    if (updateQueued) {
      return;
    }

    updateQueued = true;

    requestAnimationFrame(() => {
      updateQueued = false;
      translateButtons();
    });
  };

  const initialize = () => {
    translateButtons();

    const observer = new MutationObserver(queueUpdate);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
